<template>
  <tr :class="{'bg-warning': product.warnschwelle_config > product.quantity_sum && product.warnschwelle_config > 0 && (product.orders.length && product.orders[0].ordered_quantity ? product.quantity_sum+product.orders[0].ordered_quantity < product.warnschwelle_config : product.quantity_sum < product.warnschwelle_config)}">
    <td>
      <router-link :to="`/products/${product.id}`">
        {{ product.name }}
      </router-link>
    </td>
    <td v-text="product.product_category ? product.product_category.name : ''"></td>
    <td v-text="product.unit ? product.unit.name : ''"></td>
    <td class="text-right" v-if="hideableColumns.showEkPrice">
      {{ product.einkaufspreis | priceFromCentEuro }}
    </td>
    <td class="text-right">{{ product.price | priceFromCentEuro }}</td>
    <td class="text-right">
      {{ product.quantity_sum }}
    </td>
    <td class="text-right">
      {{ product.inventur_quantity }}
    </td>
    <td class="text-right">
      {{ product.orders.length ? product.orders[0].ordered_quantity : '' }}
    </td>
    <td class="text-right" v-if="hideableColumns.showWarnschwelle">
      {{ product.warnschwelle_config }}
    </td>
    <td class="text-right" v-if="hideableColumns.showSollMenge">
      {{ product.soll_menge_config }}
    </td>
    <td class="nowrap">{{ product.next_expiry_date | date }}</td>
    <td class="text-center" v-if="hideableColumns.showLager">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openWarehouses', product)">
        <i class="fas fa-warehouse"></i>
      </a>
    </td>
    <td class="text-center" v-if="hideableColumns.showLieferanten">
      <a class="btn btn-info btn-link btn-xs"
         @click="$emit('openSuppliers', {product, productSuppliersSorted})">
        <i class="fas fa-truck"></i>
      </a>
    </td>
  </tr>
</template>

<script>
import { groupNewestSuppliers } from 'src/util/helpers'

export default {
  props: ['product', 'onlyShowAction', 'hideableColumns'],
  computed: {
    productSuppliersSorted () {
      return groupNewestSuppliers(this.product.suppliers)
    }
  }
}
</script>

<style>
</style>
